import React, { useEffect } from 'react';
import { useGame } from '../context/GameContext.jsx';
import TopBar from './TopBar.jsx';
import Card from './Card.jsx';

const MissionScreen = () => {
  const {
    sessionId,
    currentCards,
    gameStatus,
    fetchMissionCard,
    startSession,
    translations,
    lang,
    cardLang,
    isLoading,
    setError,
  } = useGame();

  useEffect(() => {
    if (!sessionId && !isLoading) {
      console.log('MissionScreen: No session ID, redirecting to initial screen.');
      window.location.hash = 'initial';
    }
  }, [sessionId, isLoading, lang, translations]);

  useEffect(() => {
    if (sessionId && (gameStatus === 'created' || gameStatus === 'mission_ready') && currentCards.length === 0 && !isLoading) {
      console.log('MissionScreen: Fetching mission card due to state mismatch or refresh.');
      fetchMissionCard(sessionId, cardLang).catch(err => {
        console.error('Error fetching mission card in MissionScreen useEffect:', err);
        setError(translations[lang]?.error_loading_mission_card);
      });
    }
  }, [sessionId, gameStatus, currentCards.length, fetchMissionCard, isLoading, setError, translations, lang, cardLang]);

  const missionCard = currentCards.length > 0 ? currentCards[0] : null;

  if (isLoading && !missionCard) {
    return (
      <div className="screen-visible">
        <TopBar /> 
        <div className="text-center mt-5">
          <div className="spinner-border text-light" role="status">
            <span className="visually-hidden">{translations[lang]?.loading_text}</span>
          </div>
          <p className="text-light mt-3">{translations[lang]?.loading_mission_text}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="screen-visible">
      <TopBar />
      <div className="mission-screen-content d-flex flex-column align-items-center justify-content-center">
        {missionCard ? (
          <Card card={missionCard} isMissionCard={true} />
        ) : (
          <p className="text-light">{translations[lang]?.loading_text}</p>
        )}
        <button
          className="btn btn-warning btn-md mt-4 mission-start-button"
          onClick={startSession}
          disabled={isLoading}
        >
          {translations[lang]?.start_game_button}
        </button>
      </div>
    </div>
  );
};

export default MissionScreen;
